module.exports = __webpack_public_path__ + "img/87.10.pH.7f03285f.png";